import * as Yup from "yup";
import { transform as applicationTransfomer } from "./Application";

export const LicenseValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string(),
    uri: Yup.string()
        .url("Valid URL is required")
        .required("A valid URL is required."),
});

export const LicenseObjectSchema = {
    name: "",
    description: "",
    uuid: "",
    id: "",
    uri: "",
    client_code: "",
    timezone: "",
    applications: [],
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let license = Object.assign({}, LicenseObjectSchema, {
        id: parseInt(requestData.id),
        name: requestData.name,
        uuid: requestData.uuid,
        description: requestData.description,
        timezone: requestData.timezone,
        uri: requestData.uri,
        active: requestData.active,
        client_code: requestData.client_code,
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
    });

    if (requestData.applications) {
        let apps = applicationTransfomer(requestData.applications);
        license = Object.assign({}, license, { applications: apps });
    }

    return license;
}
